import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { tasksDaysAllowed, onboardingTasks } from '@ourbranch/lookups';

import BaseDialog from 'core/components/base-dialog/base-dialog';
import { Label } from 'core/components/label';
import { Button } from 'core/components/button';

import useStyles from './mi-pip-option4-learn-more-modal.styles';

const MIPipOption4LearnMoreModal = ({ open, onClose, data }) => {
  const classes = useStyles();
  const { primaryDriver, excludedResidents = [] } = data || {};
  const daysAllowed = tasksDaysAllowed[onboardingTasks.ProofOfMIPipOption4];

  return (
    <BaseDialog open={open} onClose={onClose} classes={{ paper: classes.container }}>
      <Label type="greenBig" className={classes.modalHeader}>
        MI PIP Option 4: $250K with Excluded Residents
      </Label>

      <div className={classes.section}>
        <Label type="darkGreenSmall" className={classes.sectionTitle}>
          What documents are needed?
        </Label>
        <Label type="body" className={classes.sectionContent}>
          To maintain a PIP medical limit of $250K with some excluded residents, the member will need to provide:
        </Label>
        <ul className={classes.list}>
          <li>
            <Label type="body">
              Proof of Qualified Health Coverage (QHC) for {primaryDriver || 'the primary applicant'}.
            </Label>
          </li>
          {excludedResidents.length > 0 && (
            <li>
              <Label type="body">
                Proof of QHC for all other household residents, if applicable, who opted to waive PIP coverage:{' '}
                <strong>
                  {excludedResidents.map((resident, index) => (
                    <React.Fragment key={index}>
                      {resident.name}
                      {index < excludedResidents.length - 1 ? ', ' : ''}
                    </React.Fragment>
                  ))}
                </strong>
              </Label>
            </li>
          )}
        </ul>
      </div>

      <div className={classes.section}>
        <Label type="darkGreenSmall" className={classes.sectionTitle}>
          When do they need to submit?
        </Label>
        <Label type="body" className={classes.sectionContent}>
          The member has {daysAllowed} days from their policy effective date to turn in the documents listed above.
          Without these documents, the policy's limit will be returned to the unlimited default, which will impact the
          price.
        </Label>
      </div>

      <div className={classes.section}>
        <Label type="darkGreenSmall" className={classes.sectionTitle}>
          What should you look for?
        </Label>
        <Label type="body" className={classes.sectionContent}>
          Verify that the documents show:
        </Label>
        <ul className={classes.list}>
          <li>
            <Label type="body">The correct names match those listed above</Label>
          </li>
          <li>
            <Label type="body">Coverage is current and active</Label>
          </li>
          <li>
            <Label type="body">The QHC meets Michigan's minimum requirements</Label>
          </li>
        </ul>
      </div>

      <Grid className={classes.btnContainer}>
        <Button variant="contained" color="primary" className={classes.closeBtn} onClick={onClose}>
          Close
        </Button>
      </Grid>
    </BaseDialog>
  );
};

MIPipOption4LearnMoreModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  data: PropTypes.shape({
    primaryDriver: PropTypes.string,
    excludedResidents: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string
      })
    )
  })
};

MIPipOption4LearnMoreModal.defaultProps = {
  data: {
    primaryDriver: 'the primary applicant',
    excludedResidents: []
  }
};

export default MIPipOption4LearnMoreModal;
